var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "button-wrapper", attrs: { "data-type": "default" } },
    [
      _c(
        "button",
        _vm._b(
          { staticClass: "button", attrs: { type: "submit" } },
          "button",
          Object.assign({}, _vm.$attrs),
          false
        ),
        [
          _vm.loading
            ? _c("v-progress-circular", {
                staticClass: "ondigo-btn-loading",
                attrs: {
                  indeterminate: "",
                  size: 18,
                  width: 1,
                  color: "primary",
                },
              })
            : _c("span", { class: this.icon }),
          _vm._v("\n    " + _vm._s(_vm.btnLabel) + "\n  "),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }